import axiosInstance from './axiosInstance';

export const programsAPI = {
  getGroupTrainings: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `/group-trainings/?${query}` : '/group-trainings/';
    const response = await axiosInstance.get(url);
    return response.data;
  },

  getGroupTraining: async (trainingId) => {
    const response = await axiosInstance.get(`/group-trainings/${trainingId}/`);
    return response.data;
  },

  createGroupTraining: async (payload) => {
    const response = await axiosInstance.post('/group-trainings/', payload);
    return response.data;
  },

  updateGroupTraining: async (trainingId, payload) => {
    const response = await axiosInstance.patch(`/group-trainings/${trainingId}/`, payload);
    return response.data;
  },

  deleteGroupTraining: async (trainingId) => {
    const response = await axiosInstance.delete(`/group-trainings/${trainingId}/`);
    return response.data;
  },

  subscribeGroupTraining: async (trainingId) => {
    const response = await axiosInstance.post(`/group-trainings/${trainingId}/subscribe/`);
    return response.data;
  },

  unsubscribeGroupTraining: async (trainingId) => {
    const response = await axiosInstance.post(`/group-trainings/${trainingId}/unsubscribe/`);
    return response.data;
  },

  createProgram: async (payload) => {
    const response = await axiosInstance.post('/trainings/', payload);
    return response.data;
  },

  updateProgram: async (programId, payload) => {
    const response = await axiosInstance.patch(`/trainings/${programId}/`, payload);
    return response.data;
  },

  deleteProgram: async (programId) => {
    const response = await axiosInstance.delete(`/trainings/${programId}/`);
    return response.data;
  },
};
